/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Jr_1_WInputs */

const en_cp_jr_1_w = /** @type {(inputs: Cp_Jr_1_WInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 hours · free`)
};

const id_cp_jr_1_w = /** @type {(inputs: Cp_Jr_1_WInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 jam · gratis`)
};

/**
* | output |
* | --- |
* | "2 hours · free" |
*
* @param {Cp_Jr_1_WInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_jr_1_w = /** @type {((inputs?: Cp_Jr_1_WInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Jr_1_WInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_jr_1_w(inputs)
	return en_cp_jr_1_w(inputs)
});